<template>
  <account-template
    icon="icons/google-analytics-4"
    :account="analytics"
    account-name="Analytics"
    connection-href="/google/connect/Analytics/onboarding"
    :connected-data="connectedData"
  />
</template>

<script>
import {mapGetters} from "vuex";
import AccountTemplate from "./AccountTemplate";

export default {
  components: {
    AccountTemplate,
  },
  computed: {
    ...mapGetters('onboarding', [
      'analytics'
    ]),
    connectedData() {
      if (!this.analytics) {
        return null;
      }

      return [
        {
          'title': 'Type',
          'value': this.analytics.analytics_version?.toUpperCase() ?? null,
        },
        {
          'title': 'Account ID',
          'value': this.analytics.account_id ?? null,
        },
        {
          'title': 'Property ID',
          'value': this.analytics.property_id ?? null,
        },
      ]
    }
  },
}
</script>

<style lang="scss" scoped>

</style>
